import script from "./ModalEliminarPartidaTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEliminarPartidaTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEliminarPartidaTorneo.vue?vue&type=style&index=0&id=1c8f8f52&lang=css"

const __exports__ = script;

export default __exports__